import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getShoppingCartData } from "../../../modules/getShoppingCartData";
import { Line } from "../Line/Line";
import FormatModalItems from "./FormatModalItems.jsx";

export const QuantityAtom = atom(1);
export const FinalNotesAtom = atom("");
export const RecipientNameAtom = atom("");
export const RecipientCheckbox = atom(false);

export const AdditionalSection = ({ activeModalSectionStateObj, handleCloseModal, productsState, componentsState, itemsState }) => {
  const [isChecked, setIsChecked] = useAtom(RecipientCheckbox);
  const [quantity, setQuantity] = useAtom(QuantityAtom);
  const [notes, setFinalNotes] = useAtom(FinalNotesAtom);
  const [recipient, setRecipientName] = useAtom(RecipientNameAtom);
  const { register, watch, setValue } = useForm({
    defaultValues: {
      quantity: quantity,
      finalNotes: notes,
      recipientName: recipient,
    },
  });
  const totalQuantity = watch("quantity");
  const finalNotes = watch("finalNotes");
  const recipientName = watch("recipientName");

  useEffect(() => {
    setQuantity(totalQuantity);
  }, [totalQuantity]);

  useEffect(() => {
    setFinalNotes(finalNotes);
  }, [finalNotes]);

  useEffect(() => {
    setRecipientName(recipientName);
  }, [recipientName]);

  const [cartSubmissionObj] = getShoppingCartData(productsState, componentsState, itemsState, totalQuantity, finalNotes, recipientName);

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
      setRecipientName("");
      setValue("recipientName", "");
    }
  };

  return (
    <>
      <Modal.Header>
        <Modal.Title className="mx-auto text-uppercase">Add To Cart</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column">
        <img className="mx-auto brandImage" src="/images/brand-logo.avif" alt="brand" />
        <h4 className="font-weight-bold mt-2">
          Review Your <span className="text-decoration-underline"> Final</span> Options
        </h4>
        <h6 className="text-danger mt-2 fw-bold text-center">
          <img
            className="warningIcon me-1"
            style={{ verticalAlign: "middle", position: "relative", top: "-1px" }}
            src="/images/iconWarning.png"
            alt="warning"
          />
          No changes or cancellations can be made once order is submitted
        </h6>
        <p className="text-warning text-decoration-underline">Custom Seat Cover: {productsState?.activeObj?.shopify?.displayName}</p>
        <FormatModalItems cartSubmissionObj={cartSubmissionObj} />
        <Line color="#AFAFAF" height="1px" width="85%" />
        <form>
          <div className="d-flex flex-column my-3">
            <h4 className="my-3">
              <input checked={isChecked} type="checkbox" class="custom-checkbox" onChange={handleCheckboxChange} />
              Is this seat cover for someone else?
            </h4>
            {isChecked && (
              <input
                className="input"
                {...register("recipientName", { required: true })}
                type="text"
                name="recipientName"
                placeholder="Type recipient's name"
              />
            )}
          </div>
          <Line color="#AFAFAF" height="1px" width="85%" />

          <div className="d-flex flex-column my-3">
            <h4 className="my-3">Final Order Notes</h4>
            <textarea className="mx-auto" cols={35} rows={4} {...register("finalNotes")} placeholder="Anything you'd like to mention?" />
          </div>

          <Line color="#AFAFAF" height="1px" width="85%" />

          <h4 className="font-weight-bold mt-2">Quantity</h4>
          <div className="d-flex justify-content-around my-3">
            <label htmlFor="quantity">
              <input
                min="0"
                {...register("quantity", { required: true, min: 0 })}
                type="number"
                name="quantity"
                className="form-number-input mx-1"
                id="quantity"
              />
            </label>
          </div>

          <div className="d-flex action-buttons justify-content-center mt-4">
            <button type="button" className="mx-2 px-2" style={{ backgroundColor: "grey" }} onClick={handleCloseModal}>
              Close
            </button>
            <button className="mx-2 px-2 submitBtn" onClick={() => activeModalSectionStateObj.setState("terms-conditions")}>
              Continue
            </button>
          </div>
        </form>
      </Modal.Body>
    </>
  );
};
